import { render, staticRenderFns } from "./TemplateD.vue?vue&type=template&id=4ffe1f56&scoped=true&"
import script from "./TemplateD.vue?vue&type=script&lang=js&"
export * from "./TemplateD.vue?vue&type=script&lang=js&"
import style0 from "./TemplateD.vue?vue&type=style&index=0&id=4ffe1f56&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ffe1f56",
  null
  
)

export default component.exports